package com.zaurh.mapquizwebsite.utils

import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import kotlinx.browser.window

actual fun provideSettings(context: Any?): Settings {
    return StorageSettings(window.localStorage)
}